import React from "react";
import SearchableDropdown from "./SearchableDropdown";

const DiscountControl = ({
  value,
  discountType,
  onChange,
  disabled = false,
  inputName = "discount",
  typeName = "discountType",
}) => {
  const normalizedDiscountType =
    discountType === "Percent"
      ? "%"
      : discountType === "Rupees"
        ? "₹"
        : discountType || "₹";

  return (
    <div className="d-flex justify-content-center">
      <input
        className="form-control col-md-6 noBorder"
        value={value ?? ""}
        type="number"
        onChange={onChange}
        name={inputName}
        disabled={disabled}
        style={{
          textAlign: "center",
          padding: "0px",
          marginRight: "5px",
        }}
      />
      <SearchableDropdown
        name={typeName}
        className="border-0 noBorder"
        value={normalizedDiscountType}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="₹">₹</option>
        <option value="%">%</option>
      </SearchableDropdown>
    </div>
  );
};

export default DiscountControl;
